/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetNoContractRequiredDto
 */
export interface SetNoContractRequiredDto {
    /**
     * 
     * @type {string}
     * @memberof SetNoContractRequiredDto
     */
    estimateItemId: string;
    /**
     * 
     * @type {boolean}
     * @memberof SetNoContractRequiredDto
     */
    checked: boolean;
}

/**
 * Check if a given object implements the SetNoContractRequiredDto interface.
 */
export function instanceOfSetNoContractRequiredDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimateItemId" in value;
    isInstance = isInstance && "checked" in value;

    return isInstance;
}

export function SetNoContractRequiredDtoFromJSON(json: any): SetNoContractRequiredDto {
    return SetNoContractRequiredDtoFromJSONTyped(json, false);
}

export function SetNoContractRequiredDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetNoContractRequiredDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'estimateItemId': json['estimateItemId'],
        'checked': json['checked'],
    };
}

export function SetNoContractRequiredDtoToJSON(value?: SetNoContractRequiredDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'estimateItemId': value.estimateItemId,
        'checked': value.checked,
    };
}

